import { Component, OnInit } from '@angular/core';
import { NavbarService } from './shared/services/navbar.service';
import { IWGSharedService } from './shared/services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'IWG';
  isDialogOpen = false;
  isNavShow = false;
  constructor (private sharedService: IWGSharedService, private nav:NavbarService) {
    this.sharedService.isBlurredBg.subscribe((data) => { 
      this.isDialogOpen = data;
    });
 
  }

  ngOnInit() {
    // if (localStorage.getItem('accessToken')) {
    //   this.nav.show();
    // } else {
    //   this.nav.hide();
    // }
  }

  // ngAfterViewChecked(){
  //   console.log("FINISHED");
  //   console.log(document.querySelector(".cdk-overlay-container"));
  // }
  ngOnDestroy() {
    this.sharedService.isBlurredBg.unsubscribe();
  }
}
